"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardButton = void 0;
var _styledComponents = _interopRequireDefault(require("../../styled-components.js"));
var _index = require("../../styles/index.js");
var CardButton = exports.CardButton = _styledComponents["default"].div.withConfig({
  displayName: "CardButton",
  componentId: "sc-g9vf2u-0"
})(["position:absolute;z-index:0;inset:0;cursor:pointer;background-color:transparent;border:none;width:100%;", ""], _index.browserFocusReset);